/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { notificationUnreadCount } from '../../axios/notificationUnreadCount'
import type { NotificationUnreadCountError, NotificationUnreadCountResponse } from '../../types/NotificationUnreadCount'

export const notificationUnreadCountQueryKey = () => [{ url: '/notifications/unread-count' }] as const

export type NotificationUnreadCountQueryKey = ReturnType<typeof notificationUnreadCountQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::unreadCount */
export function notificationUnreadCountQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		NotificationUnreadCountResponse,
		AxiosError<NotificationUnreadCountError>,
		NotificationUnreadCountResponse,
		NotificationUnreadCountQueryKey
	>({
		queryKey: notificationUnreadCountQueryKey(),
		queryFn: ({ signal }) => notificationUnreadCount({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::unreadCount */
export function useNotificationUnreadCount<TSelectData = NotificationUnreadCountResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					NotificationUnreadCountResponse,
					AxiosError<NotificationUnreadCountError>,
					TSelectData,
					NotificationUnreadCountQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<NotificationUnreadCountError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...notificationUnreadCountQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::unreadCount */
export function useNotificationUnreadCountSuspense<TSelectData = NotificationUnreadCountResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					NotificationUnreadCountResponse,
					AxiosError<NotificationUnreadCountError>,
					TSelectData,
					NotificationUnreadCountQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<NotificationUnreadCountError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...notificationUnreadCountQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
